// extracted by mini-css-extract-plugin
export var emailSubscribe = "email-subscribe-module--email-subscribe--e338c";
export var emailSubscribeDark = "email-subscribe-module--email-subscribe--dark--394c7";
export var emailSubscribeImage = "email-subscribe-module--email-subscribe--image--27d8b";
export var emailSubscribe__body = "email-subscribe-module--email-subscribe__body--c9da4";
export var emailSubscribe__copy = "email-subscribe-module--email-subscribe__copy--ea3f5";
export var emailSubscribe__desc = "email-subscribe-module--email-subscribe__desc--de9fa";
export var emailSubscribe__form = "email-subscribe-module--email-subscribe__form--55f65";
export var emailSubscribe__formContent = "email-subscribe-module--email-subscribe__form-content--73ee7";
export var emailSubscribe__formDesc = "email-subscribe-module--email-subscribe__form-desc--c72b7";
export var emailSubscribe__formQR = "email-subscribe-module--email-subscribe__form-QR--acecf";
export var emailSubscribe__formQRWrapper = "email-subscribe-module--email-subscribe__form-QR-wrapper--3dadf";
export var emailSubscribe__formWrapper = "email-subscribe-module--email-subscribe__form-wrapper--74cbc";
export var emailSubscribe__image = "email-subscribe-module--email-subscribe__image--fa48b";
export var emailSubscribe__imageWrapper = "email-subscribe-module--email-subscribe__image-wrapper--6b18a";
export var emailSubscribe__title = "email-subscribe-module--email-subscribe__title--e86ba";
export var mt0 = "email-subscribe-module--mt-0--b4b09";
export var mt1 = "email-subscribe-module--mt-1--3dfa1";
export var mt2 = "email-subscribe-module--mt-2--f5887";
export var mt3 = "email-subscribe-module--mt-3--b0c5a";
export var mt4 = "email-subscribe-module--mt-4--84880";
export var mt5 = "email-subscribe-module--mt-5--e87ff";
export var mt6 = "email-subscribe-module--mt-6--ce1cd";